import Geometry from "@fae/source/utility/Geometry.js"
import Audiomix from "@fae/source/engine/Audiomix.js"

export default function HandleSlowDeath({isEndOfEncounter} = {}) {
    return function(stage) {
        const dyingUnits = Object.values(stage.units).filter((unit) => {
            return unit.deathTimer !== undefined
                && unit.isDead != true
        })

        let steps = []
        dyingUnits.map((unit) => {
            if(unit.deathTimer > 1 && isEndOfEncounter != true) {
                steps.push({
                    "deltastages": [
                        {
                            "unit": {
                                "key": unit.key,
                                "deathTimer": unit.deathTimer - 1,
                            },
                        }
                    ]
                })
            } else {
                const SHUDDER = 0.1

                steps.push({"func": () => Audiomix.kill({"label": "music"})})

                // TODO: use the PlotFlourish.Shudder
                steps.push({
                    "type": "invoke skill",
                    "deltastages": stage.random.shuffle([
                        {"x": 0, "y": -SHUDDER},
                        {"x": 0, "y": SHUDDER},
                        {"x": SHUDDER, "y": 0},
                        {"x": -SHUDDER, "y": 0},
                        {"x": SHUDDER, "y": -SHUDDER},
                        {"x": -SHUDDER, "y": SHUDDER},
                        {"x": SHUDDER, "y": -SHUDDER},
                        {"x": -SHUDDER, "y": SHUDDER},
                        {"x": 0, "y": -SHUDDER},
                        {"x": 0, "y": SHUDDER},
                        {"x": SHUDDER, "y": 0},
                        {"x": -SHUDDER, "y": 0},
                        {"x": SHUDDER, "y": -SHUDDER},
                        {"x": -SHUDDER, "y": SHUDDER},
                        {"x": SHUDDER, "y": -SHUDDER},
                        {"x": -SHUDDER, "y": SHUDDER},
                    ]).map((deltaposition, index) => {
                        return {
                            "mark": index * 25,
                            "unit": {
                                "key": unit.key,
                                "position": Geometry.add(unit.position, deltaposition)
                            }
                        }
                    })
                })
                if(unit.scripts != undefined
                && unit.scripts["slowdeath"] != undefined) {
                    if(unit.scripts["slowdeath"] instanceof Array == false) {
                        unit.scripts["slowdeath"] = new Array(unit.scripts["slowdeath"])
                    }
                    if(unit.scripts["slowdeath"] != undefined) {
                        steps = steps.concat(unit.scripts["slowdeath"])
                    }
                }
                steps.push({
                    "type": "invoke skill",
                    "deltastages": [
                        // TODO: Call a similiar thing in Reactions.js
                        {
                            "mark": 500,
                            "audio": {"triggerKey": "Unit:Death"},
                        },
                        // {
                        //     "mark": 500,
                        //     "func": () => Audiomix.trigger("Ember:Music:Sad")
                        // },
                        {
                            "mark": 500,
                            "unit": {"key": unit.key, "opacity": 1}
                        },
                        {
                            "mark": 1500,
                            "unit": {"key": unit.key, "opacity": 0}
                        },
                        {
                            "mark": 2500,
                            "unit": {"key": unit.key, "isDead": true}
                        },
                    ]
                })
            }
        })
        return steps
    }
}
